import React, { Component } from 'react';
// import { bindActionCreators } from 'redux';
// import { connect } from 'react-redux';

import { Field, InputErrors } from '../form';
import {
  Tooltip
} from 'reactstrap';
import classNames from 'classnames'

import CustomDomainSelectorField from './CustomDomainSelectorField';

class CustomSlugInputField extends Component {
  
  constructor (props){
    super(props)
    
    this.focusOnInput = this.focusOnInput.bind(this)
    
    this.focusInput = null;
    this.setFocusInputRef = element => {
      this.focusInput = element;
    };
    this.formControl = null;
    this.setFormControlRef = element => {
      this.formControl = element;
    };
    
  }
  
  focusOnInput (e){
    this.focusInput.focus();
  }
  
  render () {
    const { submitting, values, customizeCTA } = this.props;
    
    return (
      <Field name="slug">
        {({ input, meta }) => (
          <React.Fragment>
            <div ref={this.setFormControlRef} className={classNames({"form-control":true, "slug-input": true, "form-control--focused": meta.active, 'is-invalid': meta.invalid})} onClick={this.focusOnInput}>
              <CustomDomainSelectorField name="domain_id" />
              <input {...input} className="form-control" type="text" ref={this.setFocusInputRef} placeholder={values.unique_slug} />
            </div>
            <InputErrors meta={{...meta, submitting}} />
            
            {customizeCTA && this.focusInput && <Tooltip placement="bottom-start" isOpen={!values.slug && !meta.active} target={() => this.formControl}>
              Customize!
            </Tooltip>}
          </React.Fragment>
        )}
      </Field>
    )
  }
}

export default CustomSlugInputField;


// WEBPACK FOOTER //
// ./src/components/Links/CustomSlugInputField.js